import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { getMenuItems } from 'src/app/helpers/menu';
import { HorizontalAppMenuComponent } from './components/horizontal-menu/horizontal-menu';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, RouterModule, HorizontalAppMenuComponent],
  styleUrls: ['./menu.scss'],
  template: `
    <div class="d-flex justify-content-end">
      <horizontal-app-menu
        [menuItems]="menuItems"
        [showExtraPages]="showExtraPages"
        [showContactPages]="showContactPages"
        [startBookingMenu]="startBookingMenu"
        [menuClassName]="menuClassName"
      >
      </horizontal-app-menu>
    </div>
  `,
})
export class AppMenuComponent {
  @Input() showExtraPages?: boolean;
  @Input() showContactPages?: boolean;
  @Input() startBookingMenu?: boolean;
  @Input() menuClassName?: string;

  menuItems = getMenuItems();
}
